import NextMailer, { mailer } from './server'

module.exports = NextMailer
module.exports.mailer = mailer
